import { render } from "../templates/dropdown-tree.html?vue&type=template&id=d252b1ac"
import script from "./dropdown-tree.vue?vue&type=script&lang=js"
export * from "./dropdown-tree.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__